'use client'

import type { ProductEventInput } from '@/lib/telemetry/product-events'
import { sanitizeProductEventProperties } from '@/lib/telemetry/product-sanitize'

function isPostHogConfigured() {
  return Boolean(process.env.NEXT_PUBLIC_POSTHOG_KEY && process.env.NEXT_PUBLIC_POSTHOG_HOST)
}

export async function captureProductEventClient(input: ProductEventInput): Promise<void> {
  if (!isPostHogConfigured()) {
    return
  }

  try {
    const posthogModule = await import('posthog-js')
    const posthog = posthogModule.default
    const properties = await sanitizeProductEventProperties(input)
    posthog.capture(input.event, properties)
  } catch (error) {
    console.error('product telemetry capture failed on client', error)
  }
}
